import { call, put } from 'redux-saga/effects';
import { actions as uiNeedsActions } from '../reducers/uiNeeds';
import { getByName } from './customizer';

export function* getBuyBack(input) {
  try {
    const ACTIVITY_NAME = 'TELCO-Buyback-banner';
    const getByNameParams = {
      ...input,
      name: ACTIVITY_NAME,
      custoType: 'activity',
    };
    const response = yield call(getByName, getByNameParams);
    if (response) {
      yield put(uiNeedsActions.saveBuyBackInfo(response));
    }
    return null;
  } catch (e) {
    console.log(e);
    return null;
  }
}
